import React from 'react'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import p from "./assets/p.png";
import down from "./assets/down.png";
import { FaBell } from "react-icons/fa"
import { Link, useNavigate } from 'react-router-dom';
import { AiOutlineMenuFold } from "react-icons/ai"

function Navbars({ active, show }) {
    const Navigate = useNavigate()
    const posting = () => {
        Navigate("/post")
    }
    const buy = () => {
        Navigate("/buy")
    }
    const list = () => {
        Navigate("/")
    }
    const buttonPress = () => {
        let sideMain = document.querySelectorAll(".side_main")
        sideMain.forEach(item => {
            item.classList.toggle("open")
        })
    }
    return (<>
        <Navbar expand="lg" className='ps-5 pe-3 ' style={{ backgroundColor: "rgba(255, 255, 255, 1)", boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)", position: "fixed", width: "100%" }}>
            <Container fluid className='pt-0'>
                <div className='d-flex gap-2 align-items-center'>
                    <AiOutlineMenuFold onClick={buttonPress} className='navbar_menu' />
                    <Navbar.Brand href="#" className='brand' onClick={() => Navigate("/")} >888 ADS</Navbar.Brand>
                </div>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll" className=''>
                    <Nav
                        className="m-auto my-2 my-lg-0 d-flex gap-3"
                        // style={{ maxHeight: '100px' }}
                        navbarScroll
                    >
                        <Nav.Link href="#action1" className='nav_items' style={{ display: show }} onClick={list}>Listings</Nav.Link>
                        <Nav.Link href="#action2" className='nav_items' onClick={posting} style={{ color: `${active === 'posting' ? "" : ""}`, display: show }}>Postings</Nav.Link>
                        <Nav.Link href="#" className='nav_items' style={{ display: show }} onClick={buy}>
                            Buy & Sell
                        </Nav.Link>
                    </Nav>
                    <Form className="d-flex align-items-center gap-2 pt-2">
                        <p className='code'>#00019298812</p>
                        <FaBell style={{ marginTop: "-13px" }} />
                        <img style={{ height: "27px", width: "27px", marginTop: "-13px" }} src={p} />
                        <p className='name'>Adam Person</p>
                        <img style={{ marginTop: "-11px" }} src={down} />

                    </Form>
                </Navbar.Collapse>
            </Container>
        </Navbar>




    </>

    )
}

export default Navbars